<template>
	<common-card title="Advanced Settings" type="minimize">
		<template v-slot:title>
			<span class="advanced-settings-card-title">Advanced Settings <span class="advanced-settings-enabled-flag" :class="{'advanced-settings-enabled': hasAdvancedSettings}">Enabled</span></span>
		</template>

		<campaigns-tooltip-label
			v-if="posts.length"
			tooltip="Never loads the campaign on the selected posts and/or pages. Does not disable automatic global output."
			label="Never load campaign on selected posts and/or pages:"
		>
			<core-form-multi-select-input
				name="settingNever"
				@input="setMultiSelectValue"
				:value="settingNever"
				:options="formattedPosts"
				class="omapi-input"
				searchPlaceholder="Type to search for posts and pages"
			/>
		</campaigns-tooltip-label>

		<campaigns-tooltip-label
			v-if="posts.length"
			tooltip="Loads the campaign on the selected posts and/or pages."
			label="Load campaign specifically on selected posts and/or pages:"
		>
			<core-form-multi-select-input
				name="settingOnly"
				@input="setMultiSelectValue"
				:value="settingOnly"
				:options="formattedPosts"
				class="omapi-input"
				searchPlaceholder="Type to search for posts and pages"
			/>
		</campaigns-tooltip-label>
		<core-loading v-if="isLoading"><h1>Loading...</h1></core-loading>
		<div>

			<campaigns-taxonomies-settings
				v-if="!isLoading"
				:campaign="campaign"
				:taxonomies="regularTaxonomies"
			/>

			<campaigns-tooltip-label
				tooltip="Loads the campaign on the selected post types and archive pages."
				label="Show on Post Types and Archives:"
			>
				<common-selectable-group
					class="text-setting omapi-input"
					type="checkbox"
					groupName="settingShow"
					:options="showOptions"
					:value="settingShow"
					@input="setValue"
				/>
			</campaigns-tooltip-label>
			<campaigns-woo-settings v-if="isWooConnected" :campaign="campaign"/>
		</div>
		<div v-if="! isWooConnected" class="omapi-woocommerce-settings omapi-woocommerce-settings__inactive">
			<div class="omapi-woocommerce-settings__logo">
				<img src="../../assets/images/logo-woocommerce.png" alt="
			WooCommerce Logo">
			</div>
			<div class="omapi-woocommerce-settings__content">
				<div class="omapi-woocommerce-settings__text">Go to <strong>OptinMonster Settings</strong> to integrate WooCommerce with the display rules in the campaign builder.</div>
				<core-button size="medium"
					color="blue"
					:isLink="true"
					:routerTo="{ name: 'settings-tab', params: { selectedTab: 'general' }}"
				>
					Go To OptinMonster Settings
				</core-button>
			</div>
		</div>
		<slot/>
	</common-card>
</template>

<script lang="js">
import { mapState, mapGetters } from 'vuex'
import { campaign } from '@/campaigns/mixins/campaign'

export default  {
	mixins : [ campaign ],
	props  : {
		campaign : {
			type     : Object,
			required : true,
		},
	},
	computed : {
		...mapGetters([ 'isFetched' ]),
		...mapGetters('wp', [ 'isWooConnected' ]),
		...mapState('wp', [ 'posts', 'postTypes', 'taxonomies' ]),
		isLoading () {
			return !this.isFetched('wpResources')
		},
		showOptions () {
			let options = []

			Object.keys(this.postTypes).forEach(index => {
				const option = { ...this.postTypes[index] }

				option.value = option.name
				option.titleTag = 'Post Type: ' + option.name

				options.push(option)

				// Add singular option.
				options.push({
					value    : 'singular___' + option.value,
					label    : 'Single ' + option.label,
					titleTag : option.titleTag,
					indented : true,
				})
			})

			options = [
				{
					value    : 'index',
					label    : 'Front Page and Search Pages',
					titleTag : 'index',
				},
				...options,
			]

			return options
		},
		regularTaxonomies () {
			const taxes = this.filterTaxonomies((tax) => {
				return 'categories' !== tax.name && !this.isWooTaxonomy(tax) && 0 < tax.terms.length
			})
			if (this.$get('taxonomies.categories')) {
				const cats = this.taxonomies.categories
				taxes.unshift({
					name  : cats.name,
					label : 'Post ' + cats.label, // Per the mockup.
					terms : cats.terms,
					for   : cats.for,
				})
			}
			return taxes
		},
		formattedPosts () {
			const transform = post => {
				const value = post.value ? post.value.toString() : ''
				return {
					...post,
					name       : post.name + (value ? ` (${value})` : ''),
					fancyLabel : post.name + (value ? ` <em>(${value})</em>` : ''),
				}
			}

			return this.posts.map(transform)
		},
	},
}
</script>
